// extracted by mini-css-extract-plugin
module.exports = {"button":"D_cq","button__primary":"D_cr","button__red":"D_cs","button__secondary":"D_ct","button__secondary__white":"D_cv","button__tertiary":"D_cw"};